// extracted by mini-css-extract-plugin
module.exports = {"NewsMainTitle":"style_NewsMainTitle__TVqbs","Title":"style_Title__1uXAe","SubTitle":"style_SubTitle__2oK6Y"};